import { render, staticRenderFns } from "./DialogCreateReport.vue?vue&type=template&id=530b2bbf"
import script from "./DialogCreateReport.vue?vue&type=script&lang=ts"
export * from "./DialogCreateReport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports